module.exports = __webpack_public_path__ + "img/no_record.590378a1.png";